module.exports = __webpack_public_path__ + "static/media/BulkLoadsUploader(config2).6ab859b8.xlsx";